import React, { useEffect, useState } from "react";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import apiClient from "./../../apiClient";

const TERMS_CONDITIONS_API = "/admin/cms?page=Terms and Conditions";

function TermsConditionsPage() {
  const [terms, setTerms] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await apiClient.get(TERMS_CONDITIONS_API);
        setTerms(res.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <MDBox
      p={3}
      display="flex"
      justifyContent="center"
      alignItems="flex-start"
      minHeight="80vh"
      bgcolor="#f5f6fa"
    >
      <MDBox
        width={{ xs: "100%", sm: "80%", md: "60%" }}
        boxShadow={3}
        borderRadius={3}
        bgcolor="#fff"
        p={4}
        mt={2}
      >
        <MDTypography variant="h3" mb={1} fontWeight="bold" color="primary.main">
          Terms and Conditions
        </MDTypography>
        <hr style={{ border: "none", borderTop: "2px solid #eee", margin: "16px 0 24px 0" }} />
        {loading && (
          <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="100px">
            <MDTypography variant="h6" color="text.secondary">
              Loading...
            </MDTypography>
          </MDBox>
        )}
        {error && (
          <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="100px">
            <MDTypography variant="h6" color="error">
              {error}
            </MDTypography>
          </MDBox>
        )}
        {!loading && !error && (
          <MDBox
            sx={{
              background: "linear-gradient(135deg, #f9fafb 80%, #e3e9f7 100%)",
              p: 4,
              borderRadius: 3,
              border: "1px solid #e0e0e0",
              boxShadow: 2,
              minHeight: "200px",
            }}
          >
            <MDTypography component="div" fontSize={16} color="text.primary">
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    terms && terms[0].description
                      ? terms[0].description.replace(/\n/g, "<br />")
                      : "",
                }}
              />
            </MDTypography>
          </MDBox>
        )}
      </MDBox>
    </MDBox>
  );
}

export default TermsConditionsPage;
